// Lucide icon: circle-question-mark (https://lucide.dev/icons/circle-question-mark)
import { CircleQuestionMark } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconQuestion = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CircleQuestionMark />
    </IconComponentStyled>
  )
}
